export default {"src":"/_next/static/media/fire_bg_orange.f513f8b2.svg","height":21,"width":24,"blurWidth":0,"blurHeight":0};